<!--Rating Starts-->
<section id="rating">
  <div class="row text-left">
    <div class="col-sm-12">
      <div class="content-header">Rating</div>
    </div>
  </div>
  <div class="row text-left" matchHeight="card">
    <!--Basic Rating Starts-->
    <div class="col-md-12 col-lg-6">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Basic Rating</h4>
          <p>Rating directive that will take care of visualising a star rating bar.</p>
        </div>
        <div class="card-content">
          <div class="card-body">
            <ngb-rating [(rate)]="currentRate"></ngb-rating>
            <p>Rate: <b>{{currentRate}}</b></p>
          </div>
        </div>
      </div>
    </div>
    <!--Basic Rating Ends-->

    <!--Custom star template Starts-->
    <div class="col-md-12 col-lg-6">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Custom star template</h4>
          <p>Custom rating template provided as child element</p>
        </div>
        <div class="card-content">
          <div class="card-body">
            <ngb-rating [(rate)]="currentRating">
              <ng-template let-fill="fill">
                <span class="star" [class.filled]="fill === 100">&#9733;</span>
              </ng-template>
            </ngb-rating>
            <p>Rate: <b>{{currentRating}}</b></p>
          </div>
        </div>
      </div>
    </div>
    <!--Custom star template Ends-->
  </div>
  <div class="row text-left" matchHeight="card">
    <!--Events and readonly ratings Starts-->
    <div class="col-md-12 col-lg-6">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Events and readonly ratings</h4>
          <p>Readonly and editable rating events.</p>
        </div>
        <div class="card-content">
          <div class="card-body">
            <ngb-rating [(rate)]="selected" (hover)="hovered=$event" (leave)="hovered=0" [readonly]="readonly"></ngb-rating>
            <p>Selected: <b>{{selected}}</b> Hovered: <b>{{hovered}}</b>
            </p>
            <button class="btn btn-sm btn-outline-{{readonly ? 'danger' : 'success'}}" (click)="readonly = !readonly">
              {{ readonly ? "readonly" : "editable"}}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!--Events and readonly ratings Ends-->

    <!--Form integration Starts-->
    <div class="col-md-12 col-lg-6">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Form integration</h4>
          <p>NgModel and reactive forms can be used without the 'rate' binding</p>
        </div>
        <div class="card-content">
          <div class="card-body">

            <div class="form-group" [class.has-success]="ctrl.valid" [class.has-danger]="ctrl.invalid">
              <ngb-rating [formControl]="ctrl"></ngb-rating>
              <div class="form-control-feedback">
                <div *ngIf="ctrl.valid">Thanks!</div>
                <div *ngIf="ctrl.errors">Please rate us</div>
              </div>
            </div>

            <p>Model: <b>{{ ctrl.value }}</b></p>
            <button class="btn btn-sm btn-outline-{{ ctrl.disabled ? 'danger' : 'success'}} mr-1" (click)="toggle()">
              {{ ctrl.disabled ? "control disabled" : " control enabled" }}
            </button>
            <button class="btn btn-sm btn-outline-primary" (click)="ctrl.setValue(null)">Clear</button>
          </div>
        </div>
      </div>
    </div>
    <!--Form integration Ends-->
  </div>
  <div class="row text-left" matchHeight="card">
    <!--Custom decimal rating Starts-->
    <div class="col-md-12 col-lg-6">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Custom decimal rating</h4>
          <p>Custom rating template provided via a variable. Shows fine-grained rating display</p>
        </div>
        <div class="card-content">
          <div class="card-body">
            <ng-template #t let-fill="fill">
              <span *ngIf="fill === 100" class="star full">&hearts;</span>
              <span *ngIf="fill === 0" class="star">&hearts;</span>
              <span *ngIf="fill < 100 && fill > 0" class="star">
                <span class="half" [style.width.%]="fill">&hearts;</span>&hearts;
              </span>
            </ng-template>

            <ngb-rating [(rate)]="decimalCurrentRate" [starTemplate]="t" [readonly]="true" max="5"></ngb-rating>
            <p>Rate: <b>{{decimalCurrentRate}}</b></p>
            <button class="btn btn-sm btn-outline-primary mr-1" (click)="decimalCurrentRate = 1.35">1.35</button>
            <button class="btn btn-sm btn-outline-primary" (click)="decimalCurrentRate = 4.72">4.72</button>
          </div>
        </div>
      </div>
    </div>
    <!--Custom decimal rating Ends-->
  </div>
</section>
<!--Rating Ends-->
